'use client'
import { useMessages, useTranslations } from 'next-intl'
import Image from 'next/image'
import SliderSection from './_components/SliderSection'
import GoldLinkButton from '@/components/GoldLinkButton'
import { useSearchParams } from 'next/navigation'

const eventsLogo = {
  'tco-dubai-2024':
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/events/logo-tco.png',
  'lvmh-miami-2024':
    'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-5-cropped.png',
}
const eventsVideo = {
  'tco-dubai-2024': '/videos/ROLZO_TCO_Dubai_CaseStudy.mp4',
  'lvmh-miami-2024': '/videos/ROLZO_LVMH.mp4',
}

const page = () => {
  const searchParams = useSearchParams()
  const eventId = searchParams.get('eventId')
  const t = useTranslations('eventCasestudy')
  const messages = useMessages()
  const services = Object.keys(
    messages.eventCasestudy[eventId].services
  ).filter((service) => service !== 'title')
  const highlights = Object.keys(
    messages.eventCasestudy[eventId].highlights.points
  )
  return (
    <main>
      <section>
        <div className='container pt-12 pb-[72px] max-w-[830px] md:px-[30px]'>
          <div>
            <Image
              src={eventsLogo[eventId]}
              width={150}
              height={100}
              className='w-[150px] h-auto'
              alt={eventId}
            />
          </div>
          <div>
            <h5 className='font-normal mb-6 text-[18px] md:text-[16px]'>
              {t(`${eventId}.duration`)}
            </h5>
            <h3 className='heading-common mb-6'>
              {t(`${eventId}.heading`)}
            </h3>
            <p className='font-light mb-5  leading-[1.6]'>
              {t(`${eventId}.description`)}
            </p>
          </div>
          <div className='mt-12'>
            <p className='font-normal mb-[30px] text-[18px] md:text-[16px]'>
              {t(`${eventId}.services.title`)}
            </p>
            <div className='flex flex-col md:flex-row gap-4'>
              {services.map((service) => (
                <div key={service} className='flex  items-center gap-3'>
                  <Image
                    src='https://storage.googleapis.com/rolzo-static-bucket/icons/tick_box.png'
                    alt=''
                    width={16}
                    height={16}
                  />
                  <span className='font-light'>
                    {t(`${eventId}.services.${service}`)}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className='mt-12'>
            <p className='font-normal mb-[30px] text-[18px] md:text-[16px]'>
              {t(`${eventId}.highlights.title`)}
            </p>
            <div className='grid grid-cols-2 md:grid-cols-6 flex-wrap w-full gap-8 md:gap-4'>
              {highlights.map((highlight) => (
                <div key={highlight} className='flex flex-col w-full gap-3'>
                  <p className='font-light text-[28px] md:text-[44px]'>
                    {t(`${eventId}.highlights.points.${highlight}.number`)}
                  </p>
                  <p className='font-light text-[18px] md:text-[16px]'>
                    {t(`${eventId}.highlights.points.${highlight}.title`)}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className='mt-12 mb-[72px]'>
            <video
              id='case_video'
              muted
              playsInline
              loop
              controls
              autoPlay
              allow='autoplay'
            >
              <source src={eventsVideo[eventId]} type='video/mp4' />
            </video>
          </div>
          <div className={`${eventId === 'tco-dubai-2024' ? 'bg-[#80d8d0]' : 'bg-[#121426] text-white'} `}>
            <div className='p-4 md:p-12'>
              <div>
                <Image
                  src={eventId === 'tco-dubai-2024' ? 'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/icon-quote-Black.png' : 'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/icon-quote-White.png'}
                  width={45}
                  height={45}
                  className='mt-5 mb-10 ml-[15px]'
                  alt=''
                />
              </div>
              <p className='font-light text-[18px] md:text-[16px] px-[35px] leading-[1.6] mb-[35px]'>
                {t(`${eventId}.testimonial.desc`)}
              </p>
              <p className='font-light text-[18px] md:text-[16px] px-[35px] leading-[1.6] mb-[35px]'>
                {t.rich(`${eventId}.testimonial.author-position`, {
                  bold: (chunks) => (
                    <span className='font-normal'>{chunks}</span>
                  ),
                })}
              </p>
            </div>
          </div>
        </div>
      </section>
      <SliderSection eventId={eventId} />
      <section className='py-24 border-t text-[#212529] border-[#CCCCCC] '>
        <div className='container text-left text-[18px] md:text-[16px]'>
          <p className='mb-4 font-normal'>
            {t(`elevateyourlevelsection.title`)}
          </p>
          <p className='mb-4 font-light leading-[1.6]'>
            {t(`elevateyourlevelsection.desc`)}
          </p>
          <div className='mt-10'>
            <GoldLinkButton
              hasGoldBackground={true}
              text='Contact us'
              href='/contact'
              className='leading-[1.5] py-[6px]'
            />
          </div>
        </div>
      </section>
    </main>
  )
}

export default page
